import { useCallback, useEffect, useState } from 'react';

const useNoInternet = () => {
    const [isInternetConnected, setIsInternetConnected] = useState(
        window.navigator.onLine,
    );

    const handleInternetConntected = useCallback(() => {
        setTimeout(() => {
            setIsInternetConnected(true);
        }, 1000);
    }, []);
    const handleInternetDisconnected = useCallback(() => {
        setIsInternetConnected(false);
    }, []);

    useEffect(() => {
        window.addEventListener('online', handleInternetConntected);
        window.addEventListener('offline', handleInternetDisconnected);

        return () => {
            window.removeEventListener('online', handleInternetConntected);
            window.removeEventListener('offline', handleInternetDisconnected);
        };
    });

    return { isInternetConnected };
};

export default useNoInternet;
